import React from 'react';
import classNames from 'classnames';

class CodeInput extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			input: '',
			loading: false,
			error: null,
			download: '',
		};
		this.handleInput = this.handleInput.bind(this);
		this.checkForReturn = this.checkForReturn.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	handleInput(e) {
		this.setState({
			input: e.target.value,
			error: null,
		});
	}
	checkForReturn(e) {
		if (e.which === 13 && this.state.input.length > 2) this.onSubmit();
	}
	onSubmit() {
		this.setState({
			loading: true,
		});

		fetch('/code', {
			method: 'post',
			body: JSON.stringify({
				code: this.state.input,
			}),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}
		})
			.then(response => response.json())
			.then(data => {
				let newState = {
					loading: false,
				};

				if (data.download) {
					newState.download = data.download;
				} else if (data.does_not_exist) {
					newState.error = 'does_not_exist';
				} else if (data.expired) {
					newState.error = 'expired';
				}

				this.setState(newState);
			})
			.catch(err => {
				this.setState({
					error: 'server',
					loading: false,
				})
			});
	}
	renderMessage() {
		if (this.state.error === 'does_not_exist') {
			return 'Whoops! That’s not a real code.';
		} else if (this.state.error === 'expired') {
			return 'Sorry, that code has expired.';
		} else if (this.state.error === 'server') {
			return 'Sorry, there’s a problem on our end. Try again later :('
		}
		return 'Enter your download code.';
	}
	getClassNamesForSubmit() {
		return classNames({
			code__submit: true,
			'code__submit--visible': this.state.input.length > 2,
			'code__submit--loading': this.state.loading,
		});
	}
	render() {
		return (
			<div className="CodeInput">
				<fieldset className={classNames('code', {
					'code--download': this.state.download,
				})}>
					<label
						htmlFor="code"
						className="code__label"
					>{this.renderMessage()}</label>
					<input
						id="code"
						className={classNames({
							code__input: true,
							loading: this.state.loading,
						})}
						type="text"
						name="code"
						placeholder="ABC"
						value={this.state.input}
						onChange={this.handleInput}
						onKeyUp={this.checkForReturn}
						disabled={this.state.loading}
					/>
					<button
						className={this.getClassNamesForSubmit()}
						onClick={this.onSubmit}
					>submit</button>
				</fieldset>
				<div className={classNames('download', {
					'download--visible': this.state.download,
				})}>
					<a href={this.state.download}>Download the album</a>
				</div>
			</div>
		);
	}
}

export default CodeInput;


// WEBPACK FOOTER //
// ./src/CodeInput.js